import styled from "styled-components";

import {
  absoluteCenter,
  alpha,
  clipBorderRadius,
  flexColumn,
  rem,
} from "@styles/Utilities.styled";


export const StyledSignIn = styled.div`
  .content {
    ${flexColumn}
    ${absoluteCenter}
    /* top: calc(50% - var(--footer-height)); */
    min-width: ${rem(450)};
    max-width: ${rem(470)};
    padding: 2.5rem 2rem 2rem 2rem;
    text-align: center;
    color: var(--clr-primary-700);
    background-color: var(--clr-white);
    border: 1px solid ${alpha("var(--clr-black)", 0.1)};
    ${clipBorderRadius("var(--border-radius-3)")}

    .logo {
      width: min(50%, ${rem(300)});
      margin-inline: auto;
    }

    .heading {
      font-size: ${rem(22)};
      margin-top: 1.5rem;
      font-weight: 500;
    }

    .sub-heading {
      margin-top: 0.5rem;
      font-size: ${rem(15)};
      color: var(--clr-gray-400);
      line-height: 1.4;
    }

    .form {
      width: 100%;
      text-align: left;
    }

    .forgot-password {
      margin-top: 1.5rem;
      color: var(--clr-primary-400);
      font-weight: 500;
      font-size: ${rem(13)};
    }
  }
`;
